import React, { useState, useEffect } from 'react'
import { Col, Row, Switch, Collapse } from 'antd'
import { Data } from 'Store/delivery-cost/types'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import CostConfig from 'Pages/DeliveryCost/CostConfig'
import { cloneDeep } from 'lodash'
import { LabelItem } from 'Components/form'
import { StatusTag } from 'Components/utilities'
const { Panel } = Collapse

type Props = {
  weightDataList: Data[]
  onUpdate: (weightDataList: Data[]) => void
}

const WeightCostConfig: React.FunctionComponent<Props> = props => {
  const { weightDataList, onUpdate } = props

  const [weightList, setweightList] = useState([] as Data[])
  const isActive = weightList && weightList.length > 0 && weightList[0]?.status === 'active'

  useEffect(() => {
    setweightList(weightDataList)
  }, [weightDataList])

  const onUpdateData = (index: number, data: Data) => {
    const newList = cloneDeep(weightList)
    newList[index] = data
    setweightList(newList)
    onUpdate(newList)
  }

  const renderStatus = (isActive: boolean) => (
    <StatusTag isPass={isActive === true} text={isActive ? 'เปิดใช้งาน' : 'ปิดใช้งาน'} />
  )

  const onSwitch = (val: boolean) => {
    const newList = {
      ...weightList[0],
      status: val ? 'active' : 'inactive',
    } as Data
    setweightList([newList])
    onUpdate([newList])
  }

  return (
    <Row gutter={[16, 8]}>
      <Col span={24}>
        <Collapse collapsible="header" ghost defaultActiveKey={['1']}>
          <Panel header="คำนวนอัตราค่าขนส่งจากน้ำหนัก" key="1">
            <SwitchStyled>
              <Switch checked={isActive} onChange={onSwitch} />
              &nbsp;
              <LabelItem label={`คำนวนอัตราค่าขนส่งจากน้ำหนัก`} />
              &nbsp;
              {renderStatus(isActive)}
            </SwitchStyled>

            {isActive &&
              cloneDeep(weightList).map((distance, index) => {
                return (
                  <Col span={24} key={`${distance.title}-${index}`}>
                    <CostConfig
                      configData={distance}
                      type="weight"
                      onUpdateData={(data: Data) => onUpdateData(index, data)}
                    />
                  </Col>
                )
              })}
          </Panel>
        </Collapse>
      </Col>
    </Row>
  )
}

const SwitchStyled = styled.div`
  margin: 10px 0;
`

const Title = styled.div`
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.bold};
  color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary};
`

export default WeightCostConfig
